<main class="maintenance">
  <img class="logo" src="assets/img/castorama-logo.svg" alt="Castorama" />

  <img class="tools" src="assets/img/maintenance-tools.png" alt="" />

  <h1>
    {{ 'maintenance.title' | translate }}<br />
    {{ 'maintenance.subtitle' | translate }}
  </h1>
</main>
